import Button from '../components/Button';
import Icon from '../components/Icon';
import type { ImageElement } from '../types/news';

type Props = {
  element: ImageElement;
  onUpload: (id: string, file: File) => void;
  onDelete: (id: string) => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  isFirst?: boolean;
  isLast?: boolean;
};

export default function ImageSection({
  element,
  onUpload,
  onDelete,
  onMoveDown,
  onMoveUp,
  isFirst,
  isLast,
}: Props) {
  const inputId = `image-upload-${element.id}`;

  function triggerFilePicker() {
    (document.getElementById(inputId) as HTMLInputElement)?.click();
  }

  return (
    <div className="border border-gray-tint-6 rounded-_20 padding-3 w-full margin-top-2">
      <div className="flex justify-between items-center margin-bottom-2">
        <h3>Bild</h3>
        <div className="flex gap-1 items-center">
          <Icon
            name="icon-arrow-up"
            size={1}
            className={
              isFirst ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
            }
            onClick={!isFirst ? onMoveUp : undefined}
          />
          <Icon
            name="icon-arrow-down"
            size={1}
            className={
              isLast ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
            }
            onClick={!isLast ? onMoveDown : undefined}
          />
          <Icon
            name="icon-bin"
            onClick={() => onDelete(element.id)}
            size={1}
            className="cursor-pointer"
          />
        </div>
      </div>

      {element.urls ? (
        <div className="flex flex-col gap-2">
          <div className="image-preview-box">
            <img src={element.urls.medium} alt="Vorschau" />
          </div>
          <Button iconName="icon-photo-landscape" onClick={triggerFilePicker}>
            Bild ersetzen
          </Button>
        </div>
      ) : (
        <div className="border border-gray-tint-7 rounded-1_5 padding-3 flex flex-col items-center justify-center gap-2">
          <p>
            {element.uploading
              ? 'Wird hochgeladen…'
              : 'Noch kein Bild hochgeladen'}
          </p>
          {!element.uploading && (
            <Button iconName="icon-photo-landscape" onClick={triggerFilePicker}>
              Bild hochladen
            </Button>
          )}
        </div>
      )}

      <input
        id={inputId}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onUpload(element.id, file);
        }}
      />
    </div>
  );
}
